import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CodeClub } from 'app/shared/models/class/club/club';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { ArticlePlaceService } from 'app/shared/services/articlePlace/article-place.service';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { environment } from 'environments/environment';

const reader = new FileReader();

export interface DialogData {
  offer: FullOffer;
}

@Component({
  selector: 'app-open-dialog-duplicate-offer',
  templateUrl: './open-dialog-duplicate-offer.component.html',
  styleUrls: ['./open-dialog-duplicate-offer.component.scss']
})
export class OpenDialogDuplicateOfferComponent implements OnInit {
  duplicateOfferForm: UntypedFormGroup;
  clubs: CodeClub[];
  userConnected: any;
  img: string;
  isLoadingPicture = false;
  file: any;

  isLoadingCreation = false;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogDuplicateOfferComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private clubService: ClubService,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private offerService: OfferService,
    private uiService: UiService,
    private articlePlaceService: ArticlePlaceService,

  ) { }

  ngOnInit(): void {
    this.initComponent();

    this.getClubs();

    if (this.data.offer.picture) {
      this.isLoadingPicture = true;
      this.getImg(this.data.offer.offerKey);
    }
    this.initForm();
  }

  duplicateOffer(): void {
    this.isLoadingCreation = true;
    let newParameter = [];

    const sourceKey = this.data.offer.offerKey;
    if (this.data.offer.parameters) {
      newParameter = this.data.offer.parameters;
    }

    const offerCopy: FullOffer = this.data.offer;
    offerCopy.offerName = this.f.offerName.value;
    offerCopy.clubCode = this.f.clubCode.value;
    offerCopy.image = '';
    offerCopy.oldImage = '';
    offerCopy.parameters = newParameter;

    delete offerCopy.offerKey;
    delete offerCopy.pricing;
    delete offerCopy.clubName;
    delete offerCopy.calculatedPrice;
    delete offerCopy.nettoPrice;
    delete offerCopy.quantityPrice;
    delete offerCopy.isPriority;
    delete offerCopy.discount;
    delete offerCopy.sessionTotalPrice;
    delete offerCopy.userKey;
    delete offerCopy.rating;
    delete offerCopy.ratingTotal;

    offerCopy.isActive = false;

    this.offerService.addOffer(offerCopy).subscribe({
      next: (offerKey) => {
        offerCopy.offerKey = offerKey;
        if (offerCopy.picture) {
          this.saveImgOffer(offerKey, this.file);
          this.uiService.showSnackbar('L\'offre a bien été dupliquée.');
          this.dialogRef.close(offerCopy);
        } else {
          this.uiService.showSnackbar('L\'offre a bien été dupliquée.');
          this.dialogRef.close(offerCopy);
        }
        this.isLoadingCreation = false;

        this.articlePlaceService.getByArticle(sourceKey).subscribe(places => {
          this.articlePlaceService.post(offerKey, places).subscribe();
        });
      },
      error: error => {
        this.uiService.showSnackbar(error.error);
        this.isLoadingCreation = false;
      }
    });
  }

  private getValues(type: string, values: any): any {
    let valueConvert = null;
    const valuesSplit = values.split('#');
    switch (type) {
      case 'valeur min/max':
        valueConvert = [
          {
            name: 'min',
            max: valuesSplit[0]
          },
          {
            name: 'max',
            max: valuesSplit[1]
          },
        ];
        break;

      case 'liste':
        valueConvert = [];
        valuesSplit.forEach(v => {
          const value = {
            name: 'valueSelect',
            value: v
          };
          valueConvert.push(value);
        });

        break;

      case 'checkbox':
        valueConvert = [];
        valuesSplit.forEach(v => {
          const value = {
            name: 'valueSelect',
            value: v
          };
          valueConvert.push(value);
        });
        break;

      default:
        valueConvert = [];
        break;

    }

    return valueConvert;

  }

  private getImg(offerKey) {
    this.offerService.getImgOffer(offerKey).subscribe({
      next: image => {
        this.file = this.dataURLtoFile(`data:image/png;base64, ${image.pictureBase64}`, `image_${offerKey}`);
        this.isLoadingPicture = false;
      }
    });
  }

  dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  private getClubs(): void {
    this.clubService.getClubs().subscribe({
      next: clubs => {
        this.clubs = clubs?.sort((a, b) => a.code.localeCompare(b.code));
      }
    });
  }

  private roleOfUser(): void {

    switch (this.userConnected.role) {
      case 'AdminMSR':
        this.f.clubCode.setValue(this.userConnected.club_code);
        this.f.clubCode.disable();
        break;
      case 'admin':
        this.f.clubCode.setValue(this.data.offer.clubCode);
        break;

      default:
        break;
    }
  }

  get f() {
    return this.duplicateOfferForm.controls;
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
  }

  private initForm(): void {
    this.duplicateOfferForm = this.formBuilder.group({
      offerName: ['', Validators.required],
      clubCode: ['', Validators.required]
    });
    this.roleOfUser();
  }

  private saveImgOffer(offerKey: number, file: any): void {
    this.offerService.uploadImg(offerKey, [file], true).subscribe({
      next: () => { }
    });
  }
}
